.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.card {
  background: var(--app-card-bg, light-dark(#fff, var(--mantine-color-dark-7)));
  border: 1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-4));
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
  transition:
    border-color 120ms ease,
    transform 120ms ease,
    box-shadow 120ms ease;
  position: relative;
  overflow: hidden;
}

.card:hover {
  border-color: light-dark(var(--mantine-color-gray-3), var(--mantine-color-dark-3));
  transform: translateY(-1px);
  box-shadow: 0 4px 10px -6px light-dark(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.3));
}

.card.urgent {
  border-color: light-dark(var(--mantine-color-red-3), rgba(255, 100, 100, 0.4));
  background: light-dark(var(--mantine-color-red-0), rgba(255, 100, 100, 0.08));
}

.card.warning {
  border-color: light-dark(var(--mantine-color-orange-3), rgba(255, 150, 80, 0.4));
  background: light-dark(var(--mantine-color-orange-0), rgba(255, 150, 80, 0.06));
}

.card.success {
  border-color: light-dark(var(--mantine-color-teal-3), rgba(80, 200, 160, 0.4));
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: light-dark(var(--mantine-color-laut-0), rgba(14, 124, 123, 0.15));
  color: light-dark(var(--mantine-color-laut-7), var(--mantine-color-laut-3));
}

.icon.urgentIcon {
  background: light-dark(var(--mantine-color-red-1), rgba(255, 100, 100, 0.2));
  color: light-dark(var(--mantine-color-red-7), var(--mantine-color-red-3));
}

.icon.warningIcon {
  background: light-dark(var(--mantine-color-orange-1), rgba(255, 150, 80, 0.2));
  color: light-dark(var(--mantine-color-orange-7), var(--mantine-color-orange-3));
}

.icon.successIcon {
  background: light-dark(var(--mantine-color-teal-1), rgba(80, 200, 160, 0.2));
  color: light-dark(var(--mantine-color-teal-7), var(--mantine-color-teal-3));
}

.title {
  font-size: 12px;
  font-weight: 600;
  color: var(--mantine-color-dimmed);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.value {
  font-size: 24px;
  font-weight: 700;
  color: inherit;
  line-height: 1.1;
  font-family: var(--font-display, inherit);
}

.value.muted {
  color: var(--mantine-color-dimmed);
}

.sub {
  font-size: 13px;
  color: light-dark(var(--mantine-color-gray-7), var(--mantine-color-gray-4));
  line-height: 1.35;
}

.cta {
  margin-top: 6px;
  font-size: 12px;
  font-weight: 500;
  color: light-dark(var(--mantine-color-laut-7), var(--mantine-color-laut-3));
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.cta.urgentCta {
  color: light-dark(var(--mantine-color-red-7), var(--mantine-color-red-3));
}

.cta.warningCta {
  color: light-dark(var(--mantine-color-orange-7), var(--mantine-color-orange-3));
}
